<template>
    <div v-if="value" class="login-dialog">
        <div class="login-body">
            <!--<i class="el-icon-close" @click="$emit('input', false)"></i>-->
            <img v-once class="login-body-img" src="./../assets/img/loginBg.jpg" alt="">
            <div class="login-content">
                <div class="login-title">欢迎登录东瀛民宿平台</div>
                <div class="login-sub">東瀛民泊にログイン</div>
                <el-input class="login-input"
                          v-model="loginForm.account"
                          placeholder="手机号"
                          prefix-icon="el-icon-user"></el-input>
                <el-input class="login-input"
                          placeholder="请输入密码"
                          type="password"
                          v-model="loginForm.password"
                          prefix-icon="el-icon-lock"></el-input>
                <div class="forget-psd">
                    <el-checkbox class="el-checkbox" v-model="checked">
                        <span style="font-size: 12px">记住我</span>
                    </el-checkbox>
                    <div class="forget-psd-btn">忘记密码？</div>
                </div>
                <div class="login-btn" v-loading="loading" @click="login">登录</div>
                <div class="login-bottom">还没有账号？<span @click="handOpenRes" class="color-red cur-p">免费注册</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LoginDialog",
        props:{
            value: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                loading: false,
                checked: false,
                showContent: false,
                loginForm:{
                    account: '',
                    password: '',
                    device_type: 'pc'
                }
            }
        },
        inject: ['reLoad'],
        created() {
            let loginInfo = window.localStorage.getItem('loginInfo');
            if (loginInfo) {
                this.loginForm = JSON.parse(atob(loginInfo));
                this.checked = true;
            }
        },
        watch:{
            value(){
                this.showContent = this.value;
            }
        },
        methods:{
            async login(){
                if(!this.loginForm.account){
                    return this.$message.warning('请输入用户名')
                }
                if(!this.loginForm.password){
                    return this.$message.warning('请输入密码')
                }
                let device = this.$randomString(10);
                window.sessionStorage.setItem('device', device);
                this.loading = true;
                let [e,data] = await this.$api.loginApi(this.loginForm)
                this.loading = false;
                if(e) return;
                if(data.status){
                    if(this.checked){
                        window.localStorage.setItem('loginInfo', btoa(JSON.stringify(this.loginForm)));
                    }
                    window.sessionStorage.setItem('token', data.result.token);
                    this.getUserInfo();
                    this.$emit('input', false)
                    this.$eventBus.$emit('isLogin')
                    this.reLoad()
                }else {
                    this.$message.warning(data.msg)
                }
            },
            async getUserInfo(){
                let [e, data] = await this.$api.getUserInfoApi();
                if(e) return;
                this.$store.commit('saveUserInfo', data.result)
            },
            handOpenRes(){
                this.$emit('input', false)
                this.$emit('openRes')
            }
        }
    }
</script>

<style scoped lang="less">
    .login-dialog{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        .login-body{
            width: 1000px;
            height: 534px;
            border-radius: 12px;
            background-color: #ffffff;
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            .el-icon-close{
                position: absolute;
                top: 20px;
                right: 20px;
                z-index: 10;
                font-size: 30px;
                cursor: pointer;
                color: #949494;
            }
            .login-body-img{
                width: 55%;
                height: 100%;
                object-fit: cover;
            }
            .login-content{
                width: 45%;
                height: 100%;
                box-sizing: border-box;
                padding: 55px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-flow: column;
            }
        }
    }

    .login-title{
        color: #2a2a2a;
        font-size: 22px;
        margin-bottom: 8px;
        text-align: left;
        width: 100%;
    }
    .login-sub{
        color: #949494;
        margin-bottom: 20px;
        font-size: 14px;
        text-align: left;
        width: 100%;
    }
    .login-input{
        margin-top: 30px;
        width: 82%;
        transform: scale(1.2);
    }
    .forget-psd{
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-size: 14px;
        .el-checkbox{
            transform-origin: 0 50%;
            transform: scale(1.2);
        }
        .forget-psd-btn{
            cursor: pointer;
            &:hover{
                color: #e44646;
            }
        }
    }
    .login-btn{
        width: 100%;
        height: 48px;
        line-height: 48px;
        text-align: center;
        color: #ffffff;
        font-size: 20px;
        background-color: #e44646;
        border-radius: 6px;
        cursor: pointer;
        margin-top: 20px;
        &:hover{
            background-color: #c62b26;
        }
    }

    .login-bottom{
        width: 100%;
        margin-top: 20px;
        text-align: left;
        font-size: 14px;
    }
</style>
